import { FC } from "react"
import Button from "@/components/shared/Button"
import { Icon, IconColor } from "@/components/shared/Icon"
import { ColorVariant } from "@/types/index"
import "./index.scss"

export interface WearableScanProps {
   onManualSelection: () => void
}

const WearableScan: FC<WearableScanProps> = ({ onManualSelection }) => (
   <div className="wearable-scan">
      <div className="wearable-scan__header">
         <Icon
            name="scanWearable"
            size="40"
            color={IconColor.HONOLULU_BLUE}
         />
         <div className="wearable-scan__title">Scan ReassureBand to assign</div>
      </div>

      <div className="wearable-scan__manual-selection">
         <div className="wearable-scan__manual-selection-text">
            Or select manually
         </div>
         <Button
            color={ColorVariant.HONOLULU_BLUE}
            onClick={onManualSelection}
         >
            Manual selection
         </Button>
      </div>
   </div>
)

export default WearableScan
